import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  getColor,
  InputArea,
  Tooltip,
  Typography,
} from "fds";
import "./index.scss";
import { DocDetailDto } from "../../types/files";
import DocAside from "../../components/DocAside";
import utilsCommon from "../../shared/utils/common";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import AiChatPage from "../../components/AIChatPage";
import { t } from "i18next";
interface PreviewAsideProps {
  activeBtnType: "comment" | "detail" | "aiChat";
  docInfo: DocDetailDto;
}
const PreviewAside: React.FC<PreviewAsideProps> = ({
  activeBtnType,
  docInfo,
}) => {
  const { addContentMemo } = useDocumentStore();
  const [memo, changeMemo] = useState("");

  const renderCommentPage = () => {
    return (
      <Box direction={"column"} classes="previewAside-comment--list">
        {docInfo.documentHistory.revisions.revision?.map((revision) =>
          revision.signs.sign?.map((item) => (
            <Box direction="column">
              <Box alignItems="center">
                <Avatar
                  name={item.userName ?? item.userId}
                  uniqueCode={utilsCommon.getUserColor(item.userType)}
                />
                <Tooltip message={item.userName} maxWidth="calc(100% - 165px)">
                  <Typography type="subtitle2" classes="mg ml-4" ellipsis>
                    {item.userName}
                  </Typography>
                </Tooltip>
                <Typography
                  type="body4_rg"
                  classes="mg ml-4"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {utilsCommon.renderDateFormat(item.signDate)}
                </Typography>
              </Box>
              <Box classes="previewAside-comment--memo">
                <Typography type="body2_rg" whiteSpace={"break-spaces"}>
                  {item.memo}
                </Typography>
              </Box>
            </Box>
          ))
        )}
      </Box>
    );
  };
  const handleAddMemo = async () => {
    let resp = await addContentMemo({
      memo: memo,
      pushSign: true,
      revisionNo: docInfo.documentInfo.revisionNo,
      syncId: docInfo.documentInfo.syncId,
    });
    if (resp.payload) {
      changeMemo("");
    } else {
    }
  };
  return (
    <Box classes="previewAside">
      {activeBtnType === "comment" && (
        <Box classes="previewAside-comment">
          <Typography type="subtitle2">{t("file.comment")}</Typography>
          <Box classes="mg mt-8">
            <InputArea
              placeholder={t("file.commentPlaceholder")}
              rows={3}
              size={"sm"}
              value={memo}
              width="100%"
              height={40}
              onChange={(e) => changeMemo(e.target.value)}
              isExtendable
              maxLength={512}
              disabled={
                docInfo?.documentInfo?.myPolicy?.uniqueId === "ONLYVIEW"
              }
              // onKeyUp={(e: any) => {
              //   if (e.code === "Enter" && !e.shiftKey) {
              //     e.preventDefault();
              //     e.stopPropagation();
              //     handleAddMemo();
              //   }
              // }}
            />
            <Button
              btnStyle="fill"
              label={t("common.post")}
              classes="previewAside-comment--register"
              onClick={handleAddMemo}
              state={memo.length === 0 ? "disable" : "default"}
              style={{ padding: "9px 15px", whiteSpace: "nowrap" }}
            />
          </Box>
          {renderCommentPage()}
        </Box>
      )}
      {activeBtnType === "detail" && (
        <DocAside
          asideInfo={{
            syncId: docInfo.documentInfo.syncId,
            revisionNo: docInfo.documentInfo.revisionNo,
            contentName: docInfo.documentInfo.contentName,
            workgroupId: docInfo.documentInfo.workgroup.workgroupId,
          }}
          isPreview
        />
      )}
      {utilsCommon.checkMenuAvailble(
        "aiChat",
        docInfo?.documentInfo,
        "preview"
      ) && (
        <Box
          style={{
            display: activeBtnType === "aiChat" ? "flex" : "none",
          }}
        >
          <AiChatPage receivedDragFiles={[docInfo.documentInfo]} />
        </Box>
      )}
    </Box>
  );
};

export default PreviewAside;
